define('Components/ProductListWidget/js/models/ProductListWidgetInstanceModel',['underscore','jquery','WidgetInstanceModel','app','models/ProductCollection'],function(_,$,WidgetInstanceModel,app,ProductCollection){
    var devaticsPrefix = 'devatics_';
    return WidgetInstanceModel.extend({
        name:'ProductListWidgetModel',
        defaults:{
            devatics_setup:false,
            devatics_await:false,
            devatics_fetched:true,
            devatics_fetching:false,
        },
        setup:function(){
            //
            var model = this;
            if(model.useDevatics()){
                model.set({
                    devatics_fetched:false,
                    devatics_fetching:false
                });
                model.listenTo(app,'dvt_setup',model.setupDevatics);
            }
        },

        setupDevatics:function(type){
              var model = this;
            if(model.useDevatics()){
                  if(type=='dvt_setup'){
                      model.set(devaticsPrefix+'setup',true);
                  }
                  if(type=='dvt_await'){
                      model.set(devaticsPrefix+'await',true);
                  }
                  if(model.get(devaticsPrefix+'setup') && model.get(devaticsPrefix+'await') && !model.get(devaticsPrefix+'fetched') && !model.get(devaticsPrefix+'fetching')){
                      model.fetchDevatics();
                  }
              }
        },
        fetchDevatics:function(i){
            var model = this;
            if(model.useDevatics()){
                //
                model.set(devaticsPrefix+'fetching',true);
                //
                var devatics_strategyId = model.getDevaticsStrategyId(),
                    devatics_options = {},
                    id_product = model.getOption('id_product'),
                    customer = app.getCustomer();
                devatics_options.strategyId = devatics_strategyId;
                devatics_options.commercialArgument = '';
                if(id_product){
                    devatics_options.source = id_product;
                    // TODO, pas de demande spécifique sur ce point, voir avec Devatics
                    //var product = app.getProduct(id_product), category;
                    //if(product && (category = product.getCategoryDefault())){
                    //    devatics_options.mask = {"category":category.id};
                    //}
                }
                if(customer.isLogged()){
                    devatics_options.clientId = customer.id;
                }
                //
                // devatics dvt_reco is global function
                //
                try {
                    function applyReco(recoId,productsIds){
                        model.set({
                            devatics_fetched: true,
                            devatics_fetching: false,
                            devatics_products: productsIds,
                            recoId: recoId
                        });
                        model.trigger('sync',model);
                    }
                    dvt_reco(devatics_strategyId,
                        // success callback
                        function (data) {
                            applyReco(data.recoId,data.ids);
                        },
                        // options
                        devatics_options,
                        // error callback
                        function () {
                            var devatics_ignoreFallback = model.p(devaticsPrefix+'ignoreFallback') === "1";
                            console.warn('devatics_ignoreFallback',devatics_ignoreFallback,model.id);
                            if(devatics_ignoreFallback){
                                applyReco('recoIgnore',[]);
                            }else{
                                var category = model.getCategory(),
                                    products = category ? category.getProducts(true, true, false, model.getCart()).pluck('id_product') : [];
                                applyReco('recoError',products);
                            }
                        }
                    );
                }catch(err){
                    console.warn('devatics n’est pas disponible ',err);
                }
            }
        },
        isLogged:function(){
            return app.getCustomer().isLogged();
        },
        isLoading:function(){
            var model = this;
            console.log('isLoading',model.useDevatics(),model.toJSON());
            return (model.useDevatics() && !model.get(devaticsPrefix+'fetched')) || (model.get('recoId') === 'recoIgnore') ;
        },
        useDevatics:function(){
            var model = this, devatics_strategyId,
                useDevatics = model.get(devaticsPrefix+'used');
            if(!((useDevatics === true)||(useDevatics === false))){
                devatics_strategyId = this.getDevaticsStrategyId();
                useDevatics = (devatics_strategyId && parseInt(devatics_strategyId)>0) == true;
                model.set(devaticsPrefix+'used',useDevatics);
            }
            return useDevatics;
        },
        getDevaticsStrategyId:function(){
            return this.p(devaticsPrefix+'strategyId');
        },
        getCategory:function(){
            return app.getCategory(this.p('categorieID'));
        },

        getProducts:function(){
            var model = this,
                p = model.productCollection;
            // si devatics n'est pas à jour
            if(!model.get(devaticsPrefix+'fetched')){return _([]);}
            //
            if(!p) {
                // cache product collection
                var devatics_product_ids = model.get(devaticsPrefix+'products'),
                    products = [],
                    nbProd = model.getProductsMax();
                // devatics products
                if(devatics_product_ids){
                    _(devatics_product_ids).each(function(id_product){
                        var product = app.getProduct(id_product);
                        if(product && (products.length<nbProd) && product.isVisibleInContext()){
                            products.push(product);
                        }
                    })
                }else{
                    // si la catégorie existe, on essaie d'utiliser ses produits
                    var category = model.getCategory();
                    products = category ? category.getProducts(true, true, false, model.getCart()).slice(0, nbProd) : [];
                }
                p = model.productCollection = new ProductCollection(products);
                //
            }
            return p;
        },
        getProductsMax:function(){
            var max = parseInt(this.p('nb_products_max'));
            if(_.isNaN(max)) max = Infinity;
            return max;
        },
        getProductsSize: function(){
            var max = this.getProductsMax(), total = this.getProducts().size();
            return total;//Math.min(max,total);
        },
        getCart: function(){
            // TODO cette référence est là par défaut
            return app.getCart();
        }
    });
});
